import React, { useEffect } from "react";
import { useMutation } from "react-query";
import * as Helpers from "../../../../../../../../utils/helpers";
import { useDispatch } from "react-redux";
import { Badge, Col, DatePicker, Form, message, Modal, Row } from "antd";
import * as Yup from "yup";
import { useFormik } from "formik";
import { serialize } from "object-to-formdata";
import { useMediaQuery } from "../../../../../../../../hooks";
import { FieldError } from "../../../../../../../../components";
import { ProjectApi } from "../../../../../../../../services";
import dayjs from "dayjs";
import { ClockCircleOutlined } from "@ant-design/icons";

const validationSchema1 = Yup.object({
  to: Yup.mixed().required("وارد کردن این فیلد الزامی است"),
  from: Yup.mixed().required("وارد کردن این فیلد الزامی است"),
});

const initialValues = {
  id: undefined,
  from: undefined,
  to: undefined,
};

const VerifyActivityModal = ({
  isOpen,
  setIsOpen,
  defaultValue,
  onFinish,
  taskId,
}) => {
  const isMobile = useMediaQuery("(max-width: 992px)");

  const dispatch = useDispatch();

  const onSubmit = (values) => {
    values.id
      ? updateTrackingMutate.mutate({
          params: { id: values.id },
          body: {
            from: Helpers.toIranTimeString(values.from),
            to: Helpers.toIranTimeString(values.to),
          },
        })
      : createTrackingMutate.mutate({
          body: {
            task_id: taskId,
            from: Helpers.toIranTimeString(values.from),
            to: Helpers.toIranTimeString(values.to),
          },
        });
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema1,
    onSubmit,
    validateOnChange: false,
    validateOnBlur: true,
  });

  const updateTrackingMutate = useMutation(ProjectApi.updateRecordTime, {
    onSuccess: (res) => {
      onFinish(res.data.time_tracking_record);
      setIsOpen(false);
    },
    onError: () => {
      message.error({ content: "خطا در ثبت اطلاعات" });
    },
  });

  const createTrackingMutate = useMutation(ProjectApi.createRecordTime, {
    onSuccess: (res) => {
      onFinish(res.data.time_tracking_record);
      setIsOpen(false);
    },
    onError: () => {
      message.error({ content: "خطا در ثبت اطلاعات" });
    },
  });

  const formLoading = updateTrackingMutate.isLoading || createTrackingMutate.isLoading;

  useEffect(() => {
    formik.setValues({
      id: defaultValue?.id,
      from: defaultValue?.from ? dayjs(defaultValue.from) : undefined,
      to: defaultValue?.to ? dayjs(defaultValue.to) : undefined,
    });
  }, [defaultValue]);

  return (
    <Modal
      title="ثبت فعالیت"
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      width={700}
      confirmLoading={formLoading}
      onOk={() => formik.submitForm()}
    >
      <Row gutter={[16, 16]} className="mt-2 mb-4">
        <Col xs={24} lg={12}>
          <Form.Item label={"شروع"}>
            <DatePicker
              showTime={true}
              className="w-100"
              placeholder="تاریخ شروع را وارد نمایید"
              value={formik.values.from || null}
              onChange={(iso) => {
                formik.setFieldValue("from", iso || undefined);
              }}
              onFocus={() => formik.setFieldTouched("from", true)}
            />
            <FieldError formik={formik} name="from" />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item label={"پایان"}>
            <DatePicker
              showTime={true}
              className="w-100"
              placeholder="تاریخ پایان را وارد نمایید"
              value={formik.values.to || null}
              onChange={(iso) => {
                formik.setFieldValue("to", iso || undefined);
              }}
              onFocus={() => formik.setFieldTouched("to", true)}
            />
            <FieldError formik={formik} name="to" />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          {formik.values.from && formik.values.to && (
            <h6 className="d-flex align-items-center gap-2">
              مجموع:{" "}
              <Badge
                color="blue"
                count={Helpers.formatTime(
                  dayjs(formik.values.to).diff(
                    dayjs(formik.values.from),
                    "second"
                  )
                )}
                style={{ fontSize: 14 }}
                status="processing"
              />
            </h6>
          )}
        </Col>
      </Row>
    </Modal>
  );
};

export default VerifyActivityModal;
